var _path, _path2, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmiley(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89042 5.78491C10.0602 5.78474 10.2262 5.83493 10.3674 5.92914C10.5086 6.02334 10.6187 6.15732 10.6838 6.31413C10.7488 6.47093 10.7659 6.64351 10.7328 6.81002C10.6997 6.97652 10.618 7.12948 10.498 7.24951C10.3779 7.36955 10.225 7.45128 10.0585 7.48436C9.89196 7.51743 9.71938 7.50037 9.56258 7.43532C9.40577 7.37028 9.27179 7.26018 9.17758 7.11896C9.08338 6.97773 9.03319 6.81174 9.03336 6.64198C9.03336 6.41467 9.12366 6.19667 9.28439 6.03594C9.44512 5.87521 9.66312 5.78491 9.89042 5.78491ZM4.99443 5.78491C5.16419 5.78474 5.33018 5.83493 5.47141 5.92914C5.61263 6.02334 5.72273 6.15732 5.78778 6.31413C5.85282 6.47093 5.86988 6.64351 5.83681 6.81002C5.80373 6.97652 5.722 7.12948 5.60196 7.24951C5.48193 7.36955 5.32897 7.45128 5.16247 7.48436C4.99596 7.51743 4.82338 7.50037 4.66658 7.43532C4.50978 7.37028 4.37579 7.26018 4.28159 7.11896C4.18738 6.97773 4.13719 6.81174 4.13736 6.64198C4.1376 6.41474 4.22797 6.19688 4.38865 6.0362C4.54933 5.87552 4.76719 5.78515 4.99443 5.78491ZM11.2086 9.89336C10.9279 11.4957 9.34838 12.6071 7.44243 12.6071C5.53647 12.6071 3.95786 11.4957 3.67715 9.89336C3.67414 9.8771 3.67237 9.86062 3.67188 9.84409C3.67188 9.61266 3.95346 9.46307 4.19984 9.54754C5.15018 9.87576 6.2589 10.043 7.44331 10.043C8.62771 10.043 9.73643 9.87576 10.6868 9.54754C10.9323 9.45955 11.2147 9.61178 11.2147 9.84409C11.214 9.86065 11.2119 9.87712 11.2086 9.89336Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5726 7.35409C13.7469 8.63609 13.5151 9.9405 12.9096 11.0839C12.3041 12.2272 11.3554 13.152 10.1969 13.7282C9.03851 14.3044 7.72861 14.5029 6.45147 14.2959C5.17434 14.0889 3.99422 13.4868 3.07709 12.5742C2.15996 11.6616 1.55196 10.4845 1.33861 9.20839C1.12526 7.93229 1.31729 6.62142 1.88769 5.46014C2.45809 4.29886 3.37816 3.34559 4.5185 2.73441C5.65885 2.12322 6.96209 1.88487 8.24494 2.05288",
    stroke: "#606060",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.7539,
    y: 2.50049,
    width: 1,
    height: 5,
    rx: 0.5,
    transform: "rotate(90 14.7539 2.50049)",
    fill: "#606060"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7539,
    y: 5.50049,
    width: 1,
    height: 5,
    rx: 0.5,
    transform: "rotate(-180 12.7539 5.50049)",
    fill: "#606060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.f50bf78f656d83c452135fa880c630f1.svg";
export { ForwardRef as ReactComponent };